module.exports = __webpack_public_path__ + "img/stldispatch_partially.fac7b2a5.svg";